import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { useAppDispatch } from "../../../redux/store";
import { setItem } from "../../redux/createOpinionReducer";
import Section from "../editors/Section";
import { styles } from "../editors/Styles";

export default function Title() {
  const dispatch = useAppDispatch();

  const title = useSelector((state: any) => state.createOpinion.values.title);
  const errors = useSelector((state: any) => state.createOpinion.errors);

  return (
    <Section
      title={`${T("mng_post_title")}${T("required")}`}
      body={
        <TextField
          onChange={(e) => dispatch(setItem({key: 'title', value: (e.target.value)}))}
          inputProps={{ maxLength: 2500 }}
          sx={ styles.inputField }
          hiddenLabel
          multiline
          value={title}
          rows={4}
          FormHelperTextProps={{ style: styles.errorOnInputField }}
          error={!!errors.title}
          helperText={errors.title}
        />
      }
    />
  )
}
